import { memo } from "react"
import { Link } from "react-router-dom"
import { SBLogo } from "@components"
import { getSbUrl } from "@helpers"
import { authService } from "@services"
import dayjs from "dayjs"

const Footer = () => (
  <div className="relative z-40 p-8 mt-4 text-center text-white bg-footer">
    <div className="flex items-start justify-between gap-y-2">
      <div className="flex flex-col items-start gap-1">
        <p className="text-base font-semibold opacity-70">Explore</p>
        <a href="https://forms.office.com/r/q46Dn6uVK4" target="_blank" rel="noreferrer" className="text-sm">Change Request</a>
        <Link to={`/feedback`} className="leading-5">
          <span className="text-sm">Feedback</span>
        </Link>

        <a href={getSbUrl("/apps/administration/support.php")} className="text-sm">Support</a>
        <button onClick={() => authService.logout(getSbUrl("/apps/shared/signout.php"))} className="text-sm">Logout</button>
      </div>

      <div className="flex flex-col items-center gap-y-2">
        <p className="text-base font-semibold opacity-70">Powered by</p>
        <SBLogo className="w-16 h-16" />
        <p className="text-sm">&copy; {dayjs().year()} SchoolBooking Ltd</p>
      </div>

      <div className="flex flex-col items-end gap-y-1">
        <p className="text-base font-semibold opacity-70">Build</p>
        <p className="text-base">{process.env.REACT_APP_SB_BUILD_NO || '1.0.0'}</p>
      </div>
    </div>
  </div>
)

export default memo(Footer)